module.exports = __webpack_public_path__ + "static/media/adas.d15cc132.png";